import React, { useState, useCallback, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import layoutContext from '../../layoutContext';
import { VOTING_TOKENS } from '../../../constants/Languages';

import Votes from './Votes';

const Voting = ({ rating, path }) => {
  const { cult } = useContext(layoutContext);
  const [browserWindow, setBrowserWindow] = useState(null);
  const [votesRating, setVotesRating] = useState(0);


  useEffect(() => {
    setBrowserWindow(window);
    !window.localStorage.getItem(`${path}-votesCount`) &&
      window.localStorage.setItem(`${path}-votesCount`,
        (Math.floor(Math.random() * 8) + 1) * (+(new Date()) % 10 + 1)
      );
    !window.localStorage.getItem(`${path}-rating`) &&
      window.localStorage.setItem(`${path}-rating`, rating);
    !window.localStorage.getItem(`${path}-votesRating`) &&
      window.localStorage.setItem(`${path}-votesRating`, 0);
  }, [browserWindow]);

  const {
    rateArticle,
    thanks,
    countVoutes,
    of,
    average,
    thanksForVote } = VOTING_TOKENS[cult];


  const votes = [];

  for (let i = 1; i <= 5; i++) {
    votes.push(i);
  }


  const averageVote = useCallback(
    (votesCount, rating, votesRating) => {
      return (((votesCount - 1) * rating + votesRating) / votesCount)
        .toFixed(2);
    }, []
  );

  const handleVote = useCallback(
    rating => {
      setVotesRating(rating);
      window.localStorage.setItem(`${path}-votesRating`, rating);
      window.localStorage.setItem(`${path}-votesCount`,
        +window.localStorage.getItem(`${path}-votesCount`) + 1);
      window.localStorage.setItem(`${path}-rating`, averageVote(
        +window.localStorage.getItem(`${path}-votesCount`),
        +window.localStorage.getItem(`${path}-rating`),
        +window.localStorage.getItem(`${path}-votesRating`),
      ));
    },
    [],
  );

  return (
    <>
      {browserWindow &&
        <div className='voting'>
          <span className='vote-text vote-text-numbers'>{`${countVoutes}: ${browserWindow.localStorage.getItem(`${path}-votesCount`)}
            ${average}
            ${browserWindow.localStorage.getItem(`${path}-rating`)}
            ${of} 5`}
          </span>
          <Votes
            text={browserWindow &&
              +localStorage.getItem(`${path}-votesRating`) !== 0
              ? thanksForVote :
              rateArticle}
            votes={votes}
            votesRating={browserWindow &&
              +localStorage.getItem(`${path}-votesRating`) !== 0
              ? +localStorage.getItem(`${path}-votesRating`) :
              votesRating}
            setVotesRating={handleVote}
            thanks={thanks}
          />
        </div>
      }
    </>
  );
};


export default Voting;

Voting.propTypes = {
  rating: PropTypes.number,
  path: PropTypes.string,
};
